var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"fp-iframe",staticStyle:{"border":"1px solid lightgray","width":"100dvw","height":"100dvh"},attrs:{"allowfullscreen":"allowfullscreen","scrolling":"no","src":"https://heyzine.com/flip-book/de580e1f39.html"}})])
}]

export { render, staticRenderFns }